import React, { useState, useEffect } from 'react';

export function AdminDashboard() {
    const [users, setUsers] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const fetchAdminData = async () => {
            try {
                const token = localStorage.getItem("token");
                const res = await fetch("/api/admin/dashboard", {
                    headers: { Authorization: "Bearer " + token },
                });
                const data = await res.json();
                if (res.ok) {
                    setUsers(data);
                } else {
                    setMessage(data.error || "Access denied");
                }
            } catch (error) {
                setMessage("Error fetching admin data");
            }
        };
        fetchAdminData();
    }, []);

    return (
       <div className="inter-font" style={{ color: "#fff" }}>
          <h2>Admin Dashboard</h2>
          {message && <p className="mt-2">{message}</p>}
          {users.length > 0 ? (
             <div>
                <h5>All Users:</h5>
                <ul className="list-group">
                   {users.map((user, idx) => (
                      <li key={idx} className="list-group-item">
                         Username: {user.username} – Admin:{" "}
                         {user.is_admin ? "Yes" : "No"}
                      </li>
                   ))}
                </ul>
             </div>
          ) : (
             <p>No user data available.</p>
          )}
       </div>
    );
}